import { LOGIN_MUTATION, LOGOUT_MUTATION, ALL_USERS_QUERY } from '@/graphql'
import { apolloClientA, apolloClientB } from '@/utils/apollo'

export const userService = {
    getUserByKey,
    logIn,
    logOut
};

function getUserByKey(key) {
console.log(key);

    return apolloClientA.mutate({
        mutation: ALL_USERS_QUERY,
        variables: {
            key: key
        }
    }).then();
}

function logIn(a, b) {

    return apolloClientB.mutate({
        mutation: LOGIN_MUTATION,
        variables: {
            email: a,
            password: b
        }
    }).then();

}

function logOut() {

    return apolloClientB.mutate({
        mutation: LOGOUT_MUTATION,
        variables: {
            logout: "true"
        }
    }).then();
}